$(function() {
	$('.pl_list_gallery').each(function() {
		var $block = $(this);
		var $items = $block.find('.pl_list_gallery__item');
		var $panels = $block.find('.pl_list_gallery__panel');
		var $images = $block.find('.pl_list_gallery__images-set');

		function activate(index) {
			$items.removeClass('is-active').attr('aria-selected', 'false');
			$panels.removeClass('is-active');
			$images.removeClass('is-active');

			$items
				.filter('[data-index="' + index + '"]')
				.addClass('is-active')
				.attr('aria-selected', 'true');
			$panels
				.filter('[data-index="' + index + '"]')
				.addClass('is-active');
			$images
				.filter('[data-index="' + index + '"]')
				.addClass('is-active');
		}

		$items.on('click', function() {
			activate($(this).data('index'));
		});

		activate(0);
	});
});
